export function getResults(options) {
    return new Promise((resolve, reject) => {
        axios.post('/ajax/used-vehicles/results', options)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getVehicle(id) {
    return new Promise((resolve, reject) => {
        axios.post('/ajax/used-vehicles/results/' + id )
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export default { getResults, getVehicle };